export const KEY_CUSTOMER="customer";